// src/firebase.js

// Import fungsi-fungsi yang dibutuhkan dari Firebase SDK
import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

// Konfigurasi Firebase Anda dibaca dari environment variables
// Pastikan nama variabel di file .env Anda diawali dengan REACT_APP_
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID // Opsional
};

// Inisialisasi Firebase App
const app = initializeApp(firebaseConfig);

// Inisialisasi service Firebase yang ingin Anda gunakan dan ekspor
export const auth = getAuth(app);
export const db = getFirestore(app);
export const storage = getStorage(app);

// Ekspor "app" utama jika sewaktu-waktu dibutuhkan
export default app;
